import { Controller } from "@hotwired/stimulus";
import $ from "jquery";
import { interpolate } from "../../../utils/string_utils";
import { roundToTwoDecimals, sum } from "../../../utils/number_utils";

export default class extends Controller {
  static targets = [
    "lineNetTotal",
    "lineGrossTotal",
    "netTotal",
    "vatTotal",
    "grossTotal",
    "lineTemplate",
    "line",
    "requiredLinesControl",
    "amountsConsistencyControl",
    "displayedLine",
  ];

  connect() {
    document.addEventListener("salesInvoice:lineUpdated", () => {
      this._computeInvoiceTotal();
    });

    document.addEventListener("salesInvoice:lineDeleted", () => {
      this._computeInvoiceTotal();
      this._controlLinePresence();
    });
  }

  addLine() {
    const templateContent = interpolate(this.lineTemplateTarget, { index: this.lineTargets.length, invoice_line: {} });
    this.lineTargets.at(-1).insertAdjacentHTML("afterEnd", templateContent);
    this._controlLinePresence();
  }

  checkAmountsConsistency() {
    if (this._isVatConsistent()) {
      this.amountsConsistencyControlTarget.value = true;
    } else {
      this.amountsConsistencyControlTarget.value = null;
    }
    $(this.amountsConsistencyControlTarget).parsley().validate();
  }

  _computeInvoiceTotal() {
    const { linesNetTotal, linesGrossTotal, linesVatTotal } = this._invoiceLineTotals();

    this.netTotalTarget.value = linesNetTotal;
    this.grossTotalTarget.value = linesGrossTotal;
    this.vatTotalTarget.value = linesVatTotal;

    [this.netTotalTarget, this.grossTotalTarget, this.vatTotalTarget].forEach((target) =>
      $(target).parsley().validate()
    );
  }

  _controlLinePresence() {
    if (this.displayedLineTargets.length === 0) {
      this.requiredLinesControlTarget.value = null;
    } else {
      this.requiredLinesControlTarget.value = true;
    }
    $(this.requiredLinesControlTarget).parsley().validate();
  }

  _invoiceLineTotals() {
    const linesNetTotal = roundToTwoDecimals(sum(this.lineNetTotalTargets));
    const linesGrossTotal = roundToTwoDecimals(sum(this.lineGrossTotalTargets));
    const linesVatTotal = roundToTwoDecimals(linesGrossTotal - linesNetTotal);

    return { linesNetTotal, linesGrossTotal, linesVatTotal };
  }

  _isVatConsistent() {
    const { linesVatTotal } = this._invoiceLineTotals();
    return linesVatTotal === this.vatTotalTarget.value;
  }
}
